import {
	cilAlignCenter,
	cilAlignLeft,
	cilAlignRight,
	cilApplicationsSettings,
	cilArrowRight,
	cilArrowTop,
	cilArrowBottom,
	cilArrowLeft,
	cilArrowCircleLeft,
	cilArrowCircleRight,
	cilArrowCircleBottom,
	cilArrowCircleTop,
	cilWarning,
	cilInfinity,
	cilMenu,
	cilBell,
	cilCalculator,
	cilChartPie,
	cilCursor,
	cilDrop,
	cilNotes,
	cilPencil,
	cilPuzzle,
	cilSpeedometer,
	cilStar,
	cilEnvelopeOpen,
	cilUser,
	cilLockLocked,
	cilLockUnlocked,
	cilReload,
	cilAccountLogout,
	cilBan,
	cilWifiSignal2,
	cilWifiSignal4,
	cilEthernet,
	cibSignal,
	cibFurryNetwork,
	cilScrubber,
	cilMagnifyingGlass,
	cilWindowRestore,
	cilSync,
	cilChevronLeft,
	cilChevronRight,
	cilChevronDoubleLeft,
	cilChevronDoubleRight,
	cilCheck,
	cilCheckAlt,
	cilCheckCircle,
	cilFlagAlt,
	cilContact,
	cilHome,
	cilCloudUpload,
	cilXCircle,
	cilNoteAdd,
	cilTouchApp,
	cilMoney,
	cibAddthis,
	cilCog,
	cilCenterFocus,
	cilFindInPage,
	cilBuilding,
	cilOptions,
	cilChevronBottom,
	cilChevronTop,
	cilFax,
	cilSpeech,
	cilTags,
	cilAnimal,
	cilPhone,
	cilSun,
	cilBraille,
	cilCalendar,
	cilX,
	cilEqualizer,
	cilApplications,
	cilAddressBook,
	cilTransfer,
	cilGraph,
	cilDog,
	cilHospital,
	cilSearch,
	cilSpreadsheet,
	cilGridSlash,
	cilBellExclamation,
	cilSwapVertical,
	cilFlip,
	cilFlipToBack,
	cilFilter,
	cilFilterSquare,
	cilListHighPriority,
	cilCash,
	cilTextSquare,
	cilLibraryAdd,
	cilNewspaper,
	cilExternalLink,
	cilPaperclip,
	cilDescription,
	cilFilterX,
	cilTruck,
	cilPen,
	cilTask,
	cilFile,
	cilAsteriskCircle,
	cilWallpaper,
	asdas,
} from '@coreui/icons';

export const icons = Object.assign({}, {
	//asdas,//-->BUAT_TEST
	cilWallpaper,
	cilAsteriskCircle,
	cilFile,
	cilTask,
	cilPen,
	cilTruck,
	cilFilterX,
	cilDescription,
	cilPaperclip,
	cilExternalLink,
	cilNewspaper,
	cilLibraryAdd,
	cilTextSquare,
	cilCash,
	cilListHighPriority,
	cilFilterSquare,
	cilFilter,
	cilFlipToBack,
	cilFlip,
	cilSwapVertical,
	cilBellExclamation,
	cilGridSlash,
	cilSpreadsheet,
	cilSearch,
	cilHospital,
	cilDog,
	cilGraph,
	cilTransfer,
	cilAddressBook,
	cilApplications,
	cilEqualizer,
	cilX,
	cilCalendar,
	cilBraille,
	cilSun,
	cilPhone,
	cilAnimal,
	cilTags,
	cilSpeech,
	cilFax,
	cilChevronTop,
	cilChevronBottom,
	cilOptions,
	cilBuilding,
	cilFindInPage,
	cilCenterFocus,
	cilCog,
	cibAddthis,
	cilMoney,
	cilTouchApp,
	cilNoteAdd,
	cilXCircle,
	cilCloudUpload,
	cilHome,
	cilContact,
	cilFlagAlt,
	cilCheckAlt,
	cilCheckCircle,
	cilCheck,
	cilChevronLeft,
	cilChevronRight,
	cilChevronDoubleLeft,
	cilChevronDoubleRight,
	cilSync,
	cilWindowRestore,
	cilMagnifyingGlass,
	cilScrubber,
	cibFurryNetwork,
	cibSignal,
	cilEthernet,
	cilWifiSignal2,
	cilWifiSignal4,
	cilBan,
	cilAccountLogout,
	cilReload,
	cilAlignCenter,
	cilAlignLeft,
	cilAlignRight,
	cilApplicationsSettings,
	cilArrowRight,
	cilArrowTop,
	cilArrowBottom,
	cilArrowLeft,
	cilArrowCircleLeft,
	cilArrowCircleTop,
	cilArrowCircleRight,
	cilArrowCircleBottom,
	cilWarning,
	cilInfinity,
	cilMenu,
	cilBell,
	cilCalculator,
	cilChartPie,
	cilCursor,
	cilDrop,
	cilNotes,
	cilPencil,
	cilPuzzle,
	cilSpeedometer,
	cilStar,
	cilEnvelopeOpen,
	cilUser,
	cilLockLocked,
	cilLockUnlocked,
});